import { useEffect, useState } from 'react';
import { angularEmit, angularService, retryWithDelay } from '../../../utils';
import { getHashPath } from '@utils/url.utils';

export function useMenuData() {
    const [menuList, setMenuList] = useState([]) as any;
    const [current, setCurrent] = useState(null) as any;
    const [allNavigations, setAllNavigations] = useState([]);

    useEffect(() => {
        retryWithDelay(() => {
            const zStatus = angularService('zStatus');
            setCurrent(localStorage.getItem('z:parent-navigation') || zStatus.parentNavigation);
        });
    }, []);

    useEffect(() => {
        retryWithDelay(() => {
            if (current) {
                const nav = angularService('zParentNavigationService');
                // @ts-ignore
                nav.get(window.configCoreNavigation, current).then((el) => {
                    const userRoles = angularService('zStatus').grantedRoles || [];
                    const items = (el || []).filter((item) => {
                        if (item.showForRoles && !item.showForRoles.some((role) => userRoles.includes(role))) {
                            return false;
                        }

                        if (item.hideForRoles && item.hideForRoles.some((role) => userRoles.includes(role))) {
                            return false;
                        }
                        return true;
                    });
                    setMenuList(items);
                });
            }
        });
    }, [current]);

    useEffect(() => {
        retryWithDelay(() => {
            if (menuList?.length) {
                // @ts-ignore
                getAllNavigations(menuList.map((m) => m.name)).then((navs) => setAllNavigations(navs));
            }
        });
    }, [menuList]);

    useEffect(() => {
        retryWithDelay(() => {
            if (allNavigations?.length) {
                const currentRoute = getHashPath();
                // @ts-ignore
                const nav = allNavigations.find((nav) => nav.parent && currentRoute.startsWith(nav.route));
                // @ts-ignore
                if (nav && nav.parent !== current) {
                    // @ts-ignore
                    navigation(nav.parent, !currentRoute.startsWith(nav.route));
                }
            }
        });
    }, [allNavigations, current]);

    function navigation(menu: string, updateUrl = true) {
        const zStatus = angularService('zStatus');

        zStatus.parentNavigation = menu;
        localStorage.setItem('z:parent-navigation', zStatus.parentNavigation);
        setCurrent(menu);

        if (!zStatus.isLoggedIn) {
            return;
        }

        if (updateUrl && zStatus.parentNavigation) {
            let path = localStorage.getItem('z:location ' + zStatus.parentNavigation);
            if (path) {
                setPath(path);
            } else {
                angularService('zNavigationService')
                    .get(window.config, zStatus.parentNavigation)
                    .then((moduleRoutes: any) => {
                        const path = moduleRoutes.filter((n) => n.parent)[0]?.route;
                        setPath(path);
                    });
            }

            function setPath(path: string) {
                if (path) {
                    let newPath = '/';
                    let newSearch = {};
                    if (path[0] == '{') {
                        path = JSON.parse(path);
                        // @ts-ignore
                        newPath = path.path;
                        newSearch = path.search;
                    } else {
                        newPath = path;
                    }

                    if (newPath !== '/logout' && newPath !== '/authorization') {
                        window.location.hash = `#${newPath}`;
                    }
                }
            }
        }

        angularEmit('z:parent-navigation');
    }

    const stored = localStorage.getItem('z:parent-navigation');

    return { menuList, current: current || stored, navigation };
}

async function getAllNavigations(productNames: string[]) {
    const navsByModule = productNames.map((p) => angularService('zNavigationService').get(window.config, p));
    return await Promise.all(navsByModule).then((res) => res.flat());
}
